import styled from 'styled-components';
import { StyledSettingBox, StyledSettingHeader } from '../SettingsModal.style';
import CurrenciesDropdown from './CurrenciesDropdown/CurrenciesDropdown';
import Checkbox from 'components/base/Checkbox';
import Text from 'components/base/Text';
import { LBInput } from '@linearb/buzz';

const StyledCostSettings = styled(StyledSettingBox)``;

const CostSetting = ({ formCostSetting }) => {
  return (
    <StyledCostSettings data-cy='styled-cost-settings'>
      <StyledSettingHeader>Estimated Cost</StyledSettingHeader>
      <section>
        <Checkbox
          onClick={() => formCostSetting.setIsEnabled(val => !val)}
          checked={formCostSetting.isEnabled}
        />
        <Text size='medium'>Show cost by FTE</Text>
      </section>
      <section>
        <CurrenciesDropdown
          disabled={!formCostSetting.isEnabled}
          value={formCostSetting.currency}
          onChange={newCurrency => formCostSetting.setCurrency(newCurrency)}
        />
        <LBInput
          disabled={!formCostSetting.isEnabled}
          value={formCostSetting.value}
          onChange={event => formCostSetting.setValue(Number(event.target.value))}
          className='w-28'
          placeholder='0'
          type='number'
        />
        <Text ml='1rem' size='medium'>
          Average yearly cost per employee
        </Text>
      </section>
    </StyledCostSettings>
  );
};

export default CostSetting;
